<template>
    <div class="data-container">
        <b-table
                show-empty
                :items="activationKeys"
                :empty-text="(loading) ? 'Loading data' : 'No activation keys found'"
                :fields="id == null ? fields : fieldsPerProduct"
                responsive
            >
            <template slot="date_uploaded" slot-scope="data">
                {{ data.value ? data.value : '-' }}
            </template>
            <template slot="date_availed" slot-scope="data">
                {{ data.value ? data.value : '-' }}
            </template>
            <template slot="mobile_number" slot-scope="data">
                {{ data.value ? data.value : '-' }}
            </template>
            <template slot="recipient_mobile_number" slot-scope="data">
                {{ data.value ? data.value : '-' }}
            </template>
            <template slot="status" slot-scope="data">
                <template v-if="data.value == 'available'">
                    <span style="border: 1px solid #5182FF; border-radius: 30px; padding: 4px 10px; color: #5182FF; font-size: 13px;" class="text-capitalize">
                        {{ data.value }}
                    </span>
                </template>
                <template v-else-if="data.value == 'sent'">
                    <span style="border: 1px solid #19C05C; border-radius: 30px; padding: 4px 10px; color: #19C05C; font-size: 13px;" class="text-capitalize">
                        {{ data.value }}
                    </span>
                </template>
            </template>
            <template slot="action" slot-scope="data">
                <b-button
                    variant="ghost btn-table-edit-activation-key mr-2"
                    @click="showEditModal(data)"
                >
                </b-button>
                <b-button
                    variant="ghost btn-table-delete-activation-key mr-2"
                    @click="showDeleteModal(data.item.id)"
                >
                </b-button>
            </template>
        </b-table>
        <div class="delete-notification" v-if="deleteModal">
            <div class="d-inline-block">
                <img src="@/assets/images/warning.svg" style="cursor: pointer; margin-top: -2px; margin-right: 13px !important;">
            </div>
            <div class="d-inline-block notification-text">
                Are you sure you want to permanently delete this code?
            </div>
            <div class="text-right" >
                <b-button :disabled="loading" variant="outline-secondary" style="border: 0px; font-size: 14px; font-family: MainFontRegular, sans-serif;" @click="deleteActivationKey()">Yes</b-button>
                <b-button :disabled="loading" variant="outline-primary" style="border: 0px; font-size: 14px; font-family: MainFontRegular, sans-serif;" @click="deleteModal = false">No</b-button>
            </div>
        </div>
        <b-modal
            title="Edit Product"
            ref="editProduct"
            hide-footer
            no-close-on-backdrop
            no-close-on-esc>
            <b-container fluid class="px-0">
                <div class="product-details-container" v-if="productDetails != null">
                    <h1 class="mb-3">Product Details</h1>
                    <h2 class="mb-1">Code</h2>
                    {{ productDetails.code }}
                    <h2 class="mb-1 mt-3">Status</h2>
                    <template v-if="productDetails.status == 'available'">
                        <span style="border: 1px solid #5182FF; border-radius: 30px; padding: 4px 10px; color: #5182FF; font-size: 13px;" class="text-capitalize">
                            {{ productDetails.status }}
                        </span>
                    </template>
                    <template v-else-if="productDetails.status == 'sent'">
                        <span style="border: 1px solid #19C05C; border-radius: 30px; padding: 4px 10px; color: #19C05C; font-size: 13px;" class="text-capitalize">
                            {{ productDetails.status }}
                        </span>
                    </template>
                    <h2 class="mb-1 mt-3">Date Uploaded</h2>
                    {{ productDetails.date_uploaded ? productDetails.date_uploaded : "-" }}
                    <hr>
                    <div class="modal-form mb-5">
                        <b-form-group
                            label="Product List"
                            class="mb-0"
                        >
                        </b-form-group>
                        <b-card no-body class="mb-1" >
                            <b-card-header header-tag="header" class="p-1" role="tab" style="background: #ffffff;">
                                <b-row no-gutters>
                                    <b-col>{{ productDetails.product_name }}</b-col>
                                    <b-col cols="1">
                                        <div
                                            v-b-toggle.accordion1
                                            class="action-button text-right"
                                        >
                                            <img
                                                src="@/assets/images/icons/collapse.svg"
                                                alt="Collapsed Icon"
                                                class="d-inline-block mr-2 when-closed"
                                                style="width: 14px; height: 14px;"
                                            />
                                            <img
                                                src="@/assets/images/icons/expand.svg"
                                                alt="Expand Icon"
                                                class="d-inline-block mr-2 when-opened"
                                                style="width: 14px; height: 14px;"
                                            />
                                        </div>
                                    </b-col>
                                </b-row>
                            </b-card-header>
                            <b-collapse id="accordion1" accordion="my-accordion" role="tabpanel">
                                <b-card-body class="p-0">
                                    <b-input-group>
                                        <b-input-group
                                            slot="prepend"
                                            class="border px-2 d-flex align-items-center"
                                        >
                                            <img
                                                src="@/assets/images/actions/search.svg"
                                                alt="Search Icon"
                                                style="width: 24px; height: 24px;"
                                            />
                                        </b-input-group>
                                        <b-form-input 
                                            placeholder="Search"
                                            style="border-radius: 0px; border-right: 0px; border-top: 0px;"
                                            v-model="productOptionsParam.payload.search.keyword"
                                            @input="setParam"
                                        ></b-form-input>
                                    </b-input-group>
                                    <template v-if="loading || dstoreInventoriesIsLoading">
                                        <p class="text-center">Loading...</p>    
                                    </template>
                                    <template v-else>
                                        <b-form-select v-model="productDetails.product_uuid" @scroll.native="loadProductList" :select-size="5" style="border: 0px;">
                                            <option v-for="(productOption, productOptionIndex) in productOptions" :key="productOptionIndex" :value="productOption.uuid">
                                                {{ productOption.name }}
                                            </option>
                                        </b-form-select>
                                    </template>
                                </b-card-body>
                            </b-collapse>
                        </b-card>
                    </div>
                    <b-btn variant="tertiary" v-bind:disabled="loading" @click="closeModal()" style="border-radius: 20px; width: 89.13px; height: 40px;">
                        Cancel
                    </b-btn>
                    <b-btn variant="primary" v-bind:disabled="loading" @click="showConfirmationModal()" class="float-right" style="border-radius: 20px; width: 102.13px; height: 40px;">
                        <template v-if="loading">
                            Saving...
                        </template>
                        <template v-else>
                            Save
                        </template>
                    </b-btn>
                </div>
            </b-container>
        </b-modal>
        <b-modal
            title="Confirmation"
            ref="confirmation"
            hide-footer
            no-close-on-backdrop
            no-close-on-esc>
            <b-container>
                <div>
                    <h4 class="text-center mb-5">Are you sure you want to update?</h4>
                    <b-btn variant="tertiary" v-bind:disabled="loading" @click="hideConfirmationModal()" style="border-radius: 20px; width: 89.13px; height: 40px;">
                        No
                    </b-btn>
                    <b-btn variant="primary" v-bind:disabled="loading" @click="updateActivationKey()" class="float-right" style="border-radius: 20px; width: 102.13px; height: 40px;">
                        Yes
                    </b-btn>
                </div>
            </b-container>
        </b-modal>
    </div>
</template>

<script>
import { mapState } from "vuex";
import _ from "lodash";

export default {
    name: "ActivationKeysTable",
    props: ["id"],
    data() {
        return {
            keyword: "",
            deleteModal: false,
            deleteKeyId: null,
            productDetails: null,
            fields: [
                {
                    key: "code",
                    label: "Codes"
                },
                {
                    key: "status",
                    label: "Status"
                },
                {
                    key: "code",
                    label: "Codes"
                },
                {
                    key: "date_uploaded",
                    label: "Date Uploaded"
                },
                {
                    key: "product_name",
                    label: "Product"
                },
                // {
                //     key: "type",
                //     label: "Product Type",
                //     sortable: true
                // },
                "action"
            ],
            fieldsPerProduct: [
                {
                    key: "code",
                    label: "Codes",
                    sortable: true
                },
                {
                    key: "status",
                    label: "Status",
                    sortable: true
                },
                {
                    key: "mobile_number",
                    sortable: true
                },
                {
                    key: "recipient_mobile_number",
                    label: "Recipient's Mobile Number",
                    sortable: true
                },
                {
                    key: "code",
                    label: "Codes",
                    sortable: true
                },
                {
                    key: "date_availed",
                    label: "Date Availed",
                    sortable: true
                },
                {
                    key: "product_name",
                    label: "Product",
                    sortable: true
                }
            ],
            productOptionsParam: {
                page: 1,
                payload: {
                    search: {
                        // paired_key: "all",
                        keyword: ""
                        // column: "all"
                    }
                }
            }
        };
    },
    computed: {
        ...mapState("dstoreActivationKeys", [
            "loading",
            "errors",
            "param",
            "activationKeys"
        ]),
        ...mapState("dstoreInventories", {
            productOptions: state => state.productOptions,
            dstoreInventoriesIsLoading: state => state.loading,
            dstoreInventoriesParam: state => state.param,
            maxPage: state => state.maxPage
        })
    },
    methods: {
        closeModal() {
            this.$refs.editProduct.hide();
        },
        updateActivationKey: async function() {
            this.productOptionsParam.payload.search.keyword = "";
            let param = {
                payload: {
                    product_activation_key_id: this.productDetails.id,
                    product_uuid: this.productDetails.product_uuid
                }
            };
            let _this = this;
            await this.$store
                .dispatch("dstoreActivationKeys/updateActivationKey", param)
                .then(() => {
                    if (_this.errors == null) {
                        this.$refs.confirmation.hide();
                        this.$refs.editProduct.hide();
                        this.getActivationKeys();
                    }
                });
        },
        errorMessage(field) {
            if (this.errors == null) {
                return "";
            }
            return this.errors[field];
        },
        isValid(field) {
            if (this.errors == null) {
                return false;
            }
            return this.errors[field] ? false : true;
        },
        getActivationKeys: async function() {
            if (this.id == null) {
                let param = {
                    page: 1,
                    payload: {
                        filters: {
                            keyword: "",
                            // product_add_on_uuid: null
                            // sort_by: "",
                            // sort_value: "",
                            // sort: ""
                        }
                    }
                };
                this.$store.commit("dstoreActivationKeys/setParam", param);
                await this.$store.dispatch(
                    "dstoreActivationKeys/getActivationKeys",
                    this.param
                );
            } else {
                let param = {
                    page: 1,
                    payload: {
                        filters: {
                            keyword: "",
                            product_add_on_uuid: this.id
                        }
                    }
                };
                this.$store.commit("dstoreActivationKeys/setParam", param);
                await this.$store.dispatch(
                    "dstoreActivationKeys/getActivationKeys",
                    this.param
                );
            }
        },
        hideConfirmationModal() {
            this.$refs.confirmation.hide();
            this.$refs.editProduct.show();
        },
        showConfirmationModal() {
            this.$refs.confirmation.show();
        },
        showEditModal(data) {
            this.productOptionsParam.payload.search.keyword = "";
            this.getProductOptions();
            this.deleteModal = false;
            this.productDetails = _.cloneDeep(data.item);
            this.$refs.editProduct.show();
        },
        showDeleteModal(id) {
            this.deleteModal = true;
            this.deleteKeyId = id;
        },
        deleteActivationKey: async function() {
            let param = {
                payload: {
                    product_activation_key_id: this.deleteKeyId
                }
            };
            await this.$store
                .dispatch("dstoreActivationKeys/deleteActivationKey", param)
                .then(() => {
                    this.deleteModal = false;
                    this.getActivationKeys();
                });
        },
        loadProductList(e) {
            if (
                e.target.offsetHeight + e.target.scrollTop >=
                e.target.scrollHeight - 1
            ) {
                if (this.productOptionsParam.page > 1 && !this.products) return;

                if (this.productOptionsParam.page < this.maxPage) {
                    this.productOptionsParam.page++;
                    this.getProductOptions();
                }
            }
        },
        getProductOptions: async function() {
            await this.$store.dispatch(
                "dstoreInventories/getProductOptions",
                this.productOptionsParam
            );
        },
        setParam: async function() {
            this.productOptionsParam.page = 1;
            // console.log(this.productOptionsParam);
            await this.$store.dispatch(
                "dstoreInventories/getProductOptions",
                this.productOptionsParam
            );
        }
    },
    created: function() {
        this.getActivationKeys();
    },
    mounted() {
        this.$root.$on("bv::modal::shown", (bvEvent, modalId) => {
            this.deleteModal = false;
        });
    }
};
</script>

<style lang="scss" scoped>
.customers-wrapper .input-group {
    border-radius: 0px;
    box-shadow: none;
    border-left: 0px !important;
    border-top: 0px !important;
}
.collapsed > .when-opened,
:not(.collapsed) > .when-closed {
    display: none !important;
}
table {
    th,
    td {
        white-space: nowrap !important;
        outline: 0 !important;
        text-align: left !important;
    }
    th:first-child {
        border-right-color: transparent !important;
    }
    th:last-child {
        text-align: left !important;
    }
}
.delete-notification {
    z-index: 99999;
    padding: 20px 10px;
    position: fixed;
    bottom: 2%;
    left: 12%;
    width: 436px;
    height: 96px;
    background: #ffffff;
    border: 1px solid #ffd231;
    box-sizing: border-box;
    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.04);
    border-radius: 5px;
    .notification-text {
        width: 90%;
        font-family: MainFontRegular, sans-serif;
        font-size: 14px;
        color: #000000;
    }
}
.product-details-container {
    h1 {
        font-family: MainFontBold, sans-serif;
        font-weight: normal;
        font-size: 18px;
        color: #2f3941;
    }
    h2 {
        font-family: MainFontRegular, sans-serif;
        font-size: 14px;
        color: #87929d;
    }
}
</style>
